import { render, staticRenderFns } from "./DocumentationContent.vue?vue&type=template&id=2c4db488&scoped=true&"
import script from "./DocumentationContent.vue?vue&type=script&lang=js&"
export * from "./DocumentationContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationContent.vue?vue&type=style&index=0&id=2c4db488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4db488",
  null
  
)

export default component.exports